import { render } from "./PaginationElement.vue?vue&type=template&id=6da1b2f4&scoped=true"
import script from "./PaginationElement.vue?vue&type=script&lang=js"
export * from "./PaginationElement.vue?vue&type=script&lang=js"

import "./PaginationElement.vue?vue&type=style&index=0&id=6da1b2f4&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da1b2f4"]])

export default __exports__